import Renderer from "./Graphics/Renderer.js";
import Texture from "./Graphics/Texture.js";
import Shader from "./Graphics/Shader.js";
import Framebuffer from "./Graphics/Framebuffer.js";
import Mesh from "./Graphics/Mesh.js";

import BoxMesh from "./Graphics/BoxMesh";

import Vector from "./Math/Vector";
import Matrix from "./Math/Matrix";
import Http from "./Http";

import FileSystem from "./FileSystem";

export default class RenderExample {

    constructor(canvas) {
        this.renderer = new Renderer(canvas);
        const gl = this.renderer.gl;

        // Get shader assets, and compile shader.
        this.shader = undefined;
        let req_vertex = FileSystem.request("data/shaders/vertex.glsl");
        let req_fragment = FileSystem.request("data/shaders/fragment.glsl");
        Promise.all([req_vertex, req_fragment]).then(([vs, fs]) => {
            this.shader = new Shader(this.renderer, {
                vertex: vs.data,
                fragment: fs.data
            });
        });

        // Creates mesh instance 
        this.mesh = new BoxMesh(this.renderer, 0.75, 0.75, 0.75);

        // Creates texture
        this.texture = new Texture(this.renderer, "data/image.jpg", {
            mipmap: false
        });

        // Create framebuffer
        this.framebuffer = new Framebuffer({
            color: new Texture(this.renderer, 320, 240, { format: gl.RGBA, mipmap: false }),
            depth: new Texture(this.renderer, 320, 240, { format: gl.ALPHA, mipmap: false })
        });

        //
        this.time = 0;

        //
        this.camera = {
            view: new Matrix(),
            proj: new Matrix(),
            comb: new Matrix()
        };
    }

    render() {
        // Skip rendering while shader is loading
        if (!this.shader) return;

        const gl = this.renderer.gl;

        //this.framebuffer.renderTo(() => {

        // 
        let asp = gl.canvas.width / gl.canvas.height;
        gl.canvas.width = $(gl.canvas).width();
        gl.canvas.height = gl.canvas.width / asp;
        this.renderer.setViewport(0, 0, gl.canvas.width, gl.canvas.height);

        // Randomly clear red
        let r = 0.8 + Math.random() * 0.2;
        this.renderer.setClearColor([0.1, 0.1, 0.1, 1.0]);
        this.renderer.clear();

        let a = this.time += 0.01;

        let d = 4;
        let c = Math.cos(a);
        let x = Math.cos(a) * c * d;
        let y = Math.sin(a) * c * d;
        let z = Math.sin(a) * d;

        let cam_position = new Vector(x, y, z);
        let cam_target = new Vector(0, 0, 0);
        let cam_up = new Vector(0, 0, 1);

        // Compute View and Projection
        Matrix.lookAt(cam_position, cam_target, cam_up, this.camera.view);
        Matrix.perspective(75, asp, 0.1, 100, this.camera.proj);
        Matrix.multiply(this.camera.proj, this.camera.view, this.camera.comb);

        // Draw Mesh
        this.mesh.draw(this.shader, {
            'u_camera': this.camera.comb,
            'u_texture': this.texture
        });
        //});

        // Copy framebuffer to main framebuffer...?
        //this.renderer.blit(this.framebuffer);
    }
}